<script setup lang="ts">
import { computed } from 'vue'
import { toCurrency } from '~/lib/toCurrency'
import { groupCartCustomizations } from '~/utils/groupCartCustomizations'
import type { CartCustomizationLike } from '~/utils/CartCustomizationLike'

const props = withDefaults(
  defineProps<{
    /** Customizations attached to the cart item. */
    customizations: CartCustomizationLike[] | null | undefined
    /** Prefix used for generated group keys. */
    groupKeyPrefix?: string
  }>(),
  {
    groupKeyPrefix: ''
  }
)

const groupedCustomizations = computed(() => groupCartCustomizations(props.customizations))

function getGroupKey(key: string): string {
  return props.groupKeyPrefix ? `${props.groupKeyPrefix}-${key}` : key
}

function getOptionKey(groupKey: string, optionKey: string): string {
  return `${getGroupKey(groupKey)}-${optionKey}`
}
</script>

<template>
  <div class="contents">
    <div
      v-for="group in groupedCustomizations"
      :key="getGroupKey(group.key)"
      class="contents"
    >
      <div class="mb-1">
        <div class="dark:text-content-level-400 text-content-level-500">
          {{ group.group_name }}:
        </div>

        <div
          v-for="option in group.options"
          :key="getOptionKey(group.key, option.key)"
        >
          <span class="dark:text-content-level-300 text-content-level-700">
            {{ option.option_name }}
            <template v-if="option.quantity > 1">
              {{ $t('common.cart.quantityMultiplier', { quantity: option.quantity }) }}
            </template>
          </span>

          <span
            v-if="option.total_price_adjustment > 0"
            class="ml-1 text-primary"
          >
            +{{ toCurrency(option.total_price_adjustment) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
